import header from './components/header/header.vue'
import footer from './components/footer/footer.vue'
import error from './components/errors/error.vue'
export default {
    install(Vue) {
        Vue.component('header-main', header)
        Vue.component('footer-main', footer)
        Vue.component('error', error)
    }
}

export { header, footer, error }


// WEBPACK FOOTER //
// ./src/main_components.js